import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type NewPostErrors = {
	content: string[];
	privacy: string[];
};

export const useNewPostErrors = ({
	isContentValid,
	isPrivacyValid,
}: {
	isContentValid: boolean;
	isPrivacyValid: boolean;
}) => {
	const { t } = useTranslation();

	const [errors, setErrors] = useState<NewPostErrors>({ content: [], privacy: [] });

	useEffect(() => {
		if (!errors.privacy.length) {
			return;
		}

		isPrivacyValid && setErrors((prev) => ({ ...prev, privacy: [] }));
	}, [errors.privacy, isPrivacyValid]);

	useEffect(() => {
		if (!errors.content.length) {
			return;
		}

		isContentValid && setErrors((prev) => ({ ...prev, content: [] }));
	}, [errors.content, isContentValid]);

	const validate = useCallback(() => {
		const errors = {
			content: isContentValid ? [] : [t('post.new.errors.content-media-required')],
			privacy: isPrivacyValid ? [] : [t('post.new.errors.privacy')],
		};

		setErrors(errors);

		return isContentValid && isPrivacyValid;
	}, [isContentValid, isPrivacyValid, t]);

	return {
		errors,
		validate,
	};
};
